var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.selector,"chips":"","label":_vm.label,"multiple":""},model:{value:(_vm.localModules),callback:function ($$v) {_vm.localModules=$$v},expression:"localModules"}})}
var staticRenderFns = []

export { render, staticRenderFns }